export const categories = [
  { slug: 'lianai', name: '恋爱', description: '甜蜜浪漫的爱情故事，感受心动瞬间', icon: 'ri-heart-line', count: 1280 },
  { slug: 'xuanyi', name: '悬疑', description: '扣人心弦的悬疑推理，层层揭开真相', icon: 'ri-search-eye-line', count: 856 },
  { slug: 'qihuan', name: '奇幻', description: '穿越异世界的奇幻冒险之旅', icon: 'ri-magic-line', count: 1024 },
  { slug: 'dongzuo', name: '动作', description: '热血沸腾的战斗场面，燃爆肾上腺素', icon: 'ri-fire-line', count: 743 },
  { slug: 'xiju', name: '喜剧', description: '轻松搞笑的日常故事，治愈不开心', icon: 'ri-emotion-laugh-line', count: 621 },
  { slug: 'kongbu', name: '恐怖', description: '惊悚刺激的恐怖故事，挑战心理极限', icon: 'ri-ghost-line', count: 398 },
  { slug: 'xuanhuan', name: '玄幻', description: '东方玄幻修真世界，凡人逆天改命', icon: 'ri-moon-line', count: 567 },
  { slug: 'dushi', name: '都市', description: '现代都市生活百态，现实与梦想交织', icon: 'ri-building-line', count: 912 },
  { slug: 'xiaoyuan', name: '校园', description: '青春校园纯爱故事，回到最美年华', icon: 'ri-book-open-line', count: 534 },
  { slug: 'BL', name: 'BL', description: '细腻动人的男男情感故事', icon: 'ri-user-heart-line', count: 689 },
];

export const categoriesMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoriesMap[cat.slug] = cat;
});

export const genreToSlug: Record<string, string> = {};
categories.forEach((cat) => {
  genreToSlug[cat.name] = cat.slug;
});